import { SxProps, Theme } from '@mui/system';

const styles = {
  total: {
    fontWeight: 700,
    fontSize: 17,
  },
  discount: {
    color: 'common.counterRed',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
